module.exports = __webpack_public_path__ + "img/messenger-eng.ac021ab0.png";